<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-title class="headline">确认停用账户</v-card-title>
      <v-card-text>
        <p>账号: {{ account.username }}</p>
        <p>Email: {{ account.email }}</p>
        <p class="red--text">确定要停用此账号吗？</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">取消</v-btn>
        <v-btn 
          color="red darken-1" 
          text 
          @click="confirmDeactivate"
          :loading="loading"
        >
          确认停用
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userApi } from '@/api/user'

export default {
  name: "DisableAccountConfirmation",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      account: {},
    };
  },
  watch: {
    item: {
      handler(newVal) {
        this.account = { ...newVal };
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },

    async confirmDeactivate() {
      this.loading = true;
      try {
        await userApi.disableJobSeekerAccount(this.account.id);
        this.close();
        this.$emit('refresh-list');
        this.$toast.success('账号已停用');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('停用失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>